import { Button, Checkbox, DatePicker, Space } from 'antd'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'
import { InfoCircleOutlined } from '@ant-design/icons'
import ModalEditCustomer from 'features/Category/components/ModalEditCustomer'
import CustomButton from 'general/components/Button/CustomButton'
import CustomSelect from 'general/components/CustomSelect'
import Option from 'general/components/CustomSelect/CustomOption'
import MenuList from 'general/components/CustomSelect/MenuList'
import { useRevalidateBuyerByTaxCode } from 'general/components/Dropdown/CustomDropdown/queries'
import BaseTextField from 'general/components/Forms/BaseTextField'
import FormLabel from 'general/components/Forms/FormLabel'
import TextFieldSelect from 'general/components/Forms/TextFieldSelect'
import {
  ACTION_TYPE,
  COMPANY_TYPE_FORM,
  INVOICE_TYPE,
  PRODUCT_PROPERTY,
} from 'general/constants/AppConstants'
import SelectOptions from 'general/constants/SelectOptions'
import ToastHelper from 'general/helpers/ToastHelper'
import {
  useMutationGetCompanyInfo,
  useMutationRefreshCompanyInfo,
} from 'hooks/Mutations/useMutationGetCompanyInfo'
import _ from 'lodash'
import { Fragment, memo, useCallback, useEffect, useRef, useState } from 'react'
import CheckCustomerStatusModal from '../CheckCustomerStatusModal'
import TaxCodeDisplay from '../TaxCodeDisplay'
import { findObjectInArray, padNumberWithZeros } from 'general/utils/Utils'
import AppRegex, {
  REGEX_CMND_CCCD,
  REGEX_IDENTIFY,
} from 'general/constants/AppRegex'
import dayjs from 'dayjs'
import locale from 'antd/es/date-picker/locale/vi_VN'
import AppData from 'general/constants/AppData'
import KTFormInput, {
  KTFormInputType,
} from 'general/components/Forms/KTFormInput'
import UploadFileCustom from '../../UploadFileCustom'
import InvoiceTradeDiscount from '../InvoiceTradeDiscount'
import ModalListInvoice from 'general/components/Modal/ModalListInvoice'
import useRouter from 'hooks/useRouter'
import { CheckboxCustom } from 'features/TaxDeductionDocuments/styled'
import ModalGuideInvoice from 'features/Invoice/components/modals/ModalGuideInvoice'
import TextFieldSelectBusinessBranch from 'general/components/Forms/TextFieldSelectBusinessBranch'
import { useAppSelector } from 'hooks/useRedux'
const TYPE = {
  GET: 'GET',
  REFRESH: 'REFRESH',
}

function InvoiceGeneralInfo(props) {
  const {
    formik,
    // currentCompany,
    buyerInfoExtendFields,
    templateInvoiceSerials,
    actionType,
    originalInvoiceInfo,
    // tableData,
    isTaxReduction,
    onCheckTaxReduction,
    isFromPOS,
    handleSelectInvoiceSerial,
    invoiceTemplateIdNewYear,
    setInvoiceTemplateIdNewYear,
    invoiceTemplateDetail,
    dataTemplateAuto,
  } = props
  const { company } = useAppSelector((state) => state.system)
  console.log('invoiceTemplateDetail', invoiceTemplateDetail)
  // const isPhuSan = process.env.REACT_APP_PROJECT_TYPE == 'HOADONDIENTU'
  const [checkCustomerStatusModalShow, setCheckCustomerStatusModalShow] =
    useState(false)
  const queryCache = useRevalidateBuyerByTaxCode()

  const [showingModalEditCustomer, setShowingModalEditCustomer] =
    useState(false)

  const { mutateAsync: getInfo, isPending: isGettingCompanyInfo } =
    useMutationGetCompanyInfo()

  const { mutateAsync: refreshInfo, isPending: isRefreshingCompanyInfo } =
    useMutationRefreshCompanyInfo()

  const [findListInvoiceModalShow, setFindListInvoiceModalShow] =
    useState(false)

  const [openGuide, setOpenGuide] = useState(false)

  const [checkInvoiceTemplate, setCheckInvoiceTemplate] = useState(false)

  const [isPhuSan, setIsPhuSan] = useState(false)

  const { navigate, query, pathname } = useRouter()

  const partsName = pathname.split('/')

  const [regionConfigs, sRegionConfigs] = useState({})

  const fetchInfoByTaxCode = async (type) => {
    if (_.isEmpty(formik.values.customerTaxCode)) {
      ToastHelper.showError('Vui lòng nhập mã số thuế hoặc căn cước công dân')
      return
    }
    if (
      !AppRegex.taxCodeNum.test(formik.values.customerTaxCode) &&
      !REGEX_IDENTIFY.REGEX_CCCD.test(formik.values.customerTaxCode)
    ) {
      ToastHelper.showError(
        'Mã số thuế không hợp lệ hoặc căn cước công dân không hợp lệ',
      )
      return
    }
    let result
    let payload = { document_type: 'TAX' }
    if (AppRegex.taxCodeNum.test(formik.values.customerTaxCode)) {
      payload.tax_code = formik.values.customerTaxCode
    } else if (REGEX_IDENTIFY.REGEX_CCCD.test(formik.values.customerTaxCode)) {
      payload.owner_id_card_number = formik.values.customerTaxCode
    }
    if (type === TYPE.REFRESH) {
      result = await refreshInfo(payload)
    } else {
      result = await getInfo(payload)
    }

    if (!result) return
    const { document_data, message } = result.data
    if (message !== 'SUCCESSFULLY') {
      formik.setFieldValue('customerFullAddress', '')
      formik.setFieldValue('customerCompanyName', '')
      formik.setFieldValue('customerName', '')
      formik.setFieldValue('customerEmail', '')
      formik.setFieldValue('customerPhone', '')
      formik.setFieldValue('dateOfOperation', '')
      formik.setFieldValue('status', '')
      formik.setFieldValue('customerAccountNumber', '')
      formik.setFieldValue('customerBankName', '')
    }

    const taxInfo = document_data.tax_informations[0]

    formik.setFieldValue(
      'customerFullAddress',
      taxInfo.company_information.address ?? '',
    )
    formik.setFieldValue(
      'customerCompanyName',
      taxInfo.company_information.official_name ?? '',
    )
    // formik.setFieldValue(
    //   'customerName',
    //   taxInfo.owner_information.full_name ?? '',
    // )
    formik.setFieldValue(
      'dateOfOperation',
      taxInfo.company_information.operation_start_date ?? '',
    )
  }

  const handleSelectCustomer = (customer) => {
    formik.setFieldValue('customerCompanyName', customer?.name ?? '')
    formik.setFieldValue('customerFullAddress', customer?.address ?? '')
    formik.setFieldValue('customerTaxCode', customer?.taxCode ?? '')
    formik.setFieldValue(
      'customerPersonalIdentificationNumber',
      customer?.identifyNumber ?? '',
    )
    formik.setFieldValue(
      'customerPassportNumber',
      customer?.passportNumber ?? '',
    )
    formik.setFieldValue('budgetUnitCode', customer?.budgetUnitCode ?? '')
    formik.setFieldValue('customerAccountNumber', customer?.bankAccount ?? '')
    formik.setFieldValue('customerBankName', customer?.bankName ?? '')
    formik.setFieldValue('customerPhone', customer?.buyerPhone ?? '')
    formik.setFieldValue('customerName', customer?.buyerName ?? '')
    formik.setFieldValue('customerEmail', customer?.buyerEmail ?? '')
  }

  const handleSelectBusinessBranch = (businessBranch) => {
    console.log('BusinessBranch', businessBranch)
    formik.setFieldValue(
      'businessBranchCode',
      businessBranch?.businessBranchCode ?? '',
    )
    formik.setFieldValue(
      'businessBranchName',
      businessBranch?.businessBranchName ?? '',
    )
    formik.setFieldValue(
      'businessBranchAddress',
      businessBranch?.businessBranchAddress ?? '',
    )
  }

  useEffect(() => {
    // fetchInfoByTaxCode();
    if (!formik?.values?.invoiceTemplateId && originalInvoiceInfo?.serial) {
      const yearCurrentInvoiceTemplate = originalInvoiceInfo?.serial.substring(
        2,
        4,
      )
      const yearNow = dayjs().year() % 100
      if (yearNow != yearCurrentInvoiceTemplate) {
        const serialNew = originalInvoiceInfo?.serial.replace(
          yearCurrentInvoiceTemplate,
          yearNow,
        )
        let dataInvoice = findObjectInArray(
          templateInvoiceSerials,
          'serial',
          serialNew,
        )
        // setInvoiceTemplateIdNewYear(dataInvoice)
        handleSelectInvoiceSerial(dataInvoice)
      }
    }
  }, [templateInvoiceSerials])

  useEffect(() => {
    // fetchInfoByTaxCode();
    let regionConfigs =
      invoiceTemplateDetail?.metadata?.region?.buyerInfo?.regionConfigs
    let itemPatientCode = findObjectInArray(
      regionConfigs,
      'dataField',
      'patientCode',
    )
    if (itemPatientCode?.show) {
      setIsPhuSan(1)
    } else {
      setIsPhuSan(null)
    }
    sRegionConfigs(regionConfigs)
  }, [invoiceTemplateDetail?.invoiceTemplateId])

  useEffect(() => {
    let dataInvoice = findObjectInArray(
      templateInvoiceSerials,
      'invoiceTemplateId',
      formik.values.invoiceTemplateId,
    )
    setInvoiceTemplateIdNewYear(dataInvoice)
  }, [formik.values.invoiceTemplateId, templateInvoiceSerials])

  const renderDescription = () => {
    if (
      actionType === ACTION_TYPE.ADJUST ||
      (actionType === ACTION_TYPE.UPDATE &&
        formik.values.type === INVOICE_TYPE.ADJUST)
    ) {
      const numberSerial = originalInvoiceInfo?.serial?.slice(0, 1)
      const letterSerial = originalInvoiceInfo?.serial?.slice(1)
      return (
        <>
          <span className="my-2">
            Điều chỉnh cho hóa đơn mẫu số{' '}
            <span className="font-weight-bolder">{numberSerial}</span>, ký hiệu{' '}
            <span className="font-weight-bolder">{letterSerial}</span>, số{' '}
            <span className="font-weight-bolder">
              {padNumberWithZeros(originalInvoiceInfo?.no, 8)}
            </span>
            , ngày{' '}
            <span className="font-weight-bolder">
              {new Date(originalInvoiceInfo?.date).getDate()}
            </span>{' '}
            tháng{' '}
            <span className="font-weight-bolder">
              {new Date(originalInvoiceInfo?.date).getMonth() + 1}
            </span>{' '}
            năm{' '}
            <span className="font-weight-bolder">
              {new Date(originalInvoiceInfo?.date).getFullYear()}
            </span>
            {/* <span className="font-weight-bolder">
              {originalInvoiceInfo?.date?.slice(0, 10)}
            </span> */}
          </span>
          <div className="d-flex flex-row align-items-center w-100">
            <span style={{ width: '140px' }}>Lý do</span>
            <div className="w-100">
              <BaseTextField
                className="flex-grow-1"
                name="description"
                fieldProps={formik.getFieldProps('description')}
                fieldMeta={formik.getFieldMeta('description')}
                fieldHelper={formik.getFieldHelpers('description')}
              />
            </div>
          </div>
        </>
      )
    }
    if (
      actionType === ACTION_TYPE.REPLACE ||
      (actionType === ACTION_TYPE.UPDATE &&
        formik.values.type === INVOICE_TYPE.REPLACE)
    ) {
      const numberSerial = originalInvoiceInfo?.serial?.slice(0, 1)
      const letterSerial = originalInvoiceInfo?.serial?.slice(1)
      return (
        <>
          <span className="my-2">
            Thay thế cho hóa đơn mẫu số{' '}
            <span className="font-weight-bolder">{numberSerial}</span>, ký hiệu{' '}
            <span className="font-weight-bolder">{letterSerial}</span>, số{' '}
            <span className="font-weight-bolder">
              {padNumberWithZeros(originalInvoiceInfo?.no, 8)}
            </span>
            , ngày{' '}
            <span className="font-weight-bolder">
              {new Date(originalInvoiceInfo?.date).getDate()}
            </span>{' '}
            tháng{' '}
            <span className="font-weight-bolder">
              {new Date(originalInvoiceInfo?.date).getMonth() + 1}
            </span>{' '}
            năm{' '}
            <span className="font-weight-bolder">
              {new Date(originalInvoiceInfo?.date).getFullYear()}
            </span>
          </span>
          <div className="d-flex flex-row align-items-center w-100">
            <span style={{ width: '140px' }}>Lý do</span>
            <div className="w-100">
              <BaseTextField
                className="flex-grow-1"
                name="description"
                fieldProps={formik.getFieldProps('description')}
                fieldMeta={formik.getFieldMeta('description')}
                fieldHelper={formik.getFieldHelpers('description')}
              />
            </div>
          </div>
        </>
      )
    }
    if (actionType === ACTION_TYPE.UPDATE) {
      return <></>
    }
  }

  const getFileNameFromUrl = (input) => {
    if (!input) return ''

    if (typeof input === 'string') {
      return input.split('/').pop().split('?')[0]
    }

    if (typeof input === 'object') {
      return input.name || input.url?.split('/').pop()
    }

    return ''
  }

  useEffect(() => {
    const handleCopy = (e) => {
      const selection = window.getSelection()

      if (!selection || selection.isCollapsed) {
        return
      }

      const selectedText = selection.toString()

      if (!selectedText) {
        return
      }

      const cleanSelectedText = selectedText.replace(/\s/g, '')

      const sellerTaxCode = formik.values?.sellerTaxCode?.replace(/-/g, '')

      if (!sellerTaxCode) {
        return
      }

      const cleanTaxCode = cleanSelectedText.replace(/-/g, '')

      if (cleanTaxCode !== sellerTaxCode) {
        return
      }

      e.preventDefault()
      e.stopPropagation()

      const taxCodeWithDash =
        sellerTaxCode.length > 10
          ? `${sellerTaxCode.slice(0, 10)}-${sellerTaxCode.slice(10)}`
          : sellerTaxCode

      e.clipboardData.setData('text/plain', taxCodeWithDash)
    }

    document.addEventListener('copy', handleCopy, true)

    return () => {
      document.removeEventListener('copy', handleCopy, true)
    }
  }, [formik.values?.sellerTaxCode])

  return (
    <>
      <div className="d-flex flex-column" style={{ gap: '10px' }}>
        <div className="d-flex flex-row justify-content-between">
          <div className="create-invoice-left-col">
            <div className="d-flex flex-row align-items-center w-100">
              <FormLabel>Đơn vị bán hàng:</FormLabel>
              <span className="">{formik.values?.sellerName}</span>
            </div>
            <div className="d-flex flex-row align-items-center w-100">
              <FormLabel>Mã số thuế:</FormLabel>
              <TaxCodeDisplay taxCode={formik.values?.sellerTaxCode} />
            </div>
            <div className="d-flex flex-row">
              <div className="d-flex flex-row align-items-center">
                <FormLabel>Địa chỉ:</FormLabel>
                <span className="">{formik.values.sellerFullAddress}</span>
              </div>
            </div>
            {invoiceTemplateDetail?.useBusinessBranch ? (
              <>
                <div className="d-flex flex-row align-items-center w-100">
                  <FormLabel>Mã ĐĐKD:</FormLabel>
                  <span className="">
                    {invoiceTemplateDetail.businessBranchCode ?? ''}
                  </span>
                </div>
                <div
                  className="d-flex flex-row"
                  style={{ flexWrap: 'wrap', gap: '10px 10px' }}
                >
                  <div
                    className="d-flex flex-row align-items-center"
                    style={{ width: '49.45%' }}
                  >
                    <FormLabel>Tên ĐĐKD:</FormLabel>
                    <span className="">
                      {invoiceTemplateDetail.businessBranchName ?? ''}
                    </span>
                  </div>
                  <div
                    className="d-flex flex-row align-items-center"
                    style={{ width: '49.45%' }}
                  >
                    <FormLabel>Địa chỉ ĐĐKD:</FormLabel>
                    <span className="">
                      {invoiceTemplateDetail.businessBranchAddress ?? ''}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
            {invoiceTemplateIdNewYear?.category?.form == 3 && (
              <div className="d-flex flex-row">
                <div className="d-flex flex-row align-items-center">
                  <FormLabel>Số tài khoản:</FormLabel>
                  <span className="">
                    {formik.values.sellerAccountNumber} -{` `}
                    {formik.values.sellerBankName}
                  </span>
                </div>
              </div>
            )}
            {invoiceTemplateIdNewYear?.category?.form == 3 && (
              <div
                className="d-flex flex-row"
                style={{ flexWrap: 'wrap', gap: '10px 10px' }}
              >
                {[
                  {
                    label: 'Bán theo Quyết định số:',
                    name: 'saleDecisionNo',
                    type: KTFormInputType.text,
                  },
                  {
                    label: 'Ngày:',
                    name: 'dateSaleDecisionNo',
                    type: KTFormInputType.date,
                  },
                ].map(({ label, name, type }) => (
                  <div
                    key={name}
                    className="d-flex flex-row align-items-center flex-grow-1"
                  >
                    <FormLabel>{label}</FormLabel>
                    <div className="w-100">
                      {(() => {
                        switch (type) {
                          case KTFormInputType.text:
                            return (
                              <BaseTextField
                                className="flex-grow-1"
                                name={name}
                                fieldProps={formik.getFieldProps(name)}
                                fieldMeta={formik.getFieldMeta(name)}
                                fieldHelper={formik.getFieldHelpers(name)}
                              />
                            )

                          case KTFormInputType.date:
                            return (
                              <DatePicker
                                style={{ height: 40, width: '100%' }}
                                placement="bottomLeft"
                                allowClear={true}
                                changeOnBlur
                                name={name}
                                value={formik.values[name]}
                                onChange={(date) => {
                                  formik.setFieldValue(name, date)
                                }}
                                locale={locale}
                                // showTime={canSelectTime}
                                format={'L' /*  : 'L' */}
                                suffixIcon={
                                  <i className="fa-light fa-calendar"></i>
                                }
                                nextIcon={
                                  <i className="fa-regular fa-angle-right"></i>
                                }
                                prevIcon={
                                  <i className="fa-regular fa-angle-left"></i>
                                }
                                superNextIcon={
                                  <i className="fa-regular fa-angle-double-right"></i>
                                }
                                superPrevIcon={
                                  <i className="fa-regular fa-angle-double-left"></i>
                                }
                              />
                            )

                          default:
                            return null
                        }
                      })()}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {invoiceTemplateIdNewYear?.category?.form == 3 && (
              <div className="d-flex flex-row">
                <div className="d-flex flex-row align-items-center w-100">
                  <FormLabel>Cơ quan ban hành quyết định:</FormLabel>
                  <div className="w-100">
                    <BaseTextField
                      className="flex-grow-1 w-100"
                      name="decisionIssuingAgency"
                      fieldProps={formik.getFieldProps('decisionIssuingAgency')}
                      fieldMeta={formik.getFieldMeta('decisionIssuingAgency')}
                      fieldHelper={formik.getFieldHelpers(
                        'decisionIssuingAgency',
                      )}
                    />
                  </div>
                </div>
              </div>
            )}
            {invoiceTemplateIdNewYear?.category?.form == 3 && (
              <div className="d-flex flex-row">
                <div className="d-flex flex-row align-items-center w-100">
                  <FormLabel>Hình thức bán:</FormLabel>
                  <div className="w-100">
                    <BaseTextField
                      className="flex-grow-1 w-100"
                      name="saleMethod"
                      fieldProps={formik.getFieldProps('saleMethod')}
                      fieldMeta={formik.getFieldMeta('saleMethod')}
                      fieldHelper={formik.getFieldHelpers('saleMethod')}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* {isPhuSan && (
              <div className="d-flex flex-row align-items-center w-100">
                <FormLabel>Khoa:</FormLabel>
                <div className="w-100">
                  <BaseTextField
                    className="flex-grow-1 w-100"
                    name="department"
                    fieldProps={formik.getFieldProps('department')}
                    fieldMeta={formik.getFieldMeta('department')}
                    fieldHelper={formik.getFieldHelpers('department')}
                  />
                </div>
              </div>
            )} */}
            <div className="d-flex flex-row align-items-center  w-100">
              <FormLabel>
                <span>
                  MST,CCCD người mua:{' '}
                  <KTTooltip text="Mã số thuế, Căn cước công dân của người mua">
                    <InfoCircleOutlined
                      style={{ color: '#1677ff', cursor: 'pointer' }}
                    />
                  </KTTooltip>
                </span>
              </FormLabel>
              <div style={{ width: '35%' }}>
                <TextFieldSelect
                  className="flex-grow-1 w-100"
                  fieldHelper={formik.getFieldHelpers('customerTaxCode')}
                  fieldMeta={formik.getFieldMeta('customerTaxCode')}
                  fieldProps={formik.getFieldProps('customerTaxCode')}
                  onCreateNew={() => {
                    setShowingModalEditCustomer(true)
                  }}
                  onSelect={handleSelectCustomer}
                />
              </div>
              <CustomButton
                marginLeft={8}
                color="#304FFD"
                text="Lấy thông tin"
                backgroundColor="white"
                // width="120px"
                onClick={fetchInfoByTaxCode}
                loading={isGettingCompanyInfo}
                disabled={isGettingCompanyInfo}
                spinnerColorClassName="spinner-primary"
              />
              <CustomButton
                marginLeft={8}
                icon={`fa-regular fa-arrows-rotate ${isRefreshingCompanyInfo ? 'fa-spin' : ''}`}
                color="#304FFD"
                backgroundColor="white"
                // width="120px"
                onClick={() => {
                  fetchInfoByTaxCode(TYPE.REFRESH)
                }}
                loading={isRefreshingCompanyInfo}
                disabled={isRefreshingCompanyInfo}
                spinnerColorClassName="hidden"
                description="Cập nhật thông tin người mua hàng"
              />
              <CustomButton
                marginLeft={8}
                color="#304FFD"
                text="KT tình trạng hoạt động của KH"
                backgroundColor="white"
                width="250px"
                onClick={() => {
                  setCheckCustomerStatusModalShow(true)
                }}
              />
            </div>
            {invoiceTemplateIdNewYear?.category?.form == 3 && (
              <div className="d-flex flex-row">
                <div className="d-flex flex-row align-items-center w-100">
                  <FormLabel>MSĐVCQHVNS:</FormLabel>
                  <div className="w-100">
                    <BaseTextField
                      className="flex-grow-1 w-100"
                      name="budgetUnitCode"
                      fieldProps={formik.getFieldProps('budgetUnitCode')}
                      fieldMeta={formik.getFieldMeta('budgetUnitCode')}
                      fieldHelper={formik.getFieldHelpers('budgetUnitCode')}
                    />
                  </div>
                </div>
              </div>
            )}
            {[
              {
                label: (
                  <>
                    Tên đơn vị{' '}
                    {invoiceTemplateIdNewYear?.category?.form == 3 && (
                      <span className="text-danger">(*)</span>
                    )}
                    :
                  </>
                ),
                name: 'customerCompanyName',
              },
              {
                label: (
                  <>
                    Địa chỉ{' '}
                    {invoiceTemplateIdNewYear?.category?.form == 3 && (
                      <span className="text-danger">(*)</span>
                    )}
                    :
                  </>
                ),
                name: 'customerFullAddress',
              },
            ].map(({ label, name }) => (
              <div
                key={name}
                className="d-flex flex-row align-items-center w-100"
              >
                <FormLabel>{label} </FormLabel>
                <div className="w-100">
                  <BaseTextField
                    className="flex-grow-1 w-100"
                    name={name}
                    fieldProps={formik.getFieldProps(name)}
                    fieldMeta={formik.getFieldMeta(name)}
                    fieldHelper={formik.getFieldHelpers(name)}
                  />
                </div>
              </div>
            ))}
            <div
              className="d-flex flex-row"
              style={{ flexWrap: 'wrap', gap: '10px 10px' }}
            >
              {[
                {
                  label:
                    invoiceTemplateIdNewYear?.category?.form == 3
                      ? `Người mua tài sản:`
                      : `Người mua hàng:`,
                  name: 'customerName',
                  description:
                    invoiceTemplateIdNewYear?.category?.form != 3 ? (
                      <>
                        Trường hợp người mua là người tiêu dùng không cung cấp
                        tên, địa chỉ, số định danh cá nhân thì trên hóa đơn thể
                        hiện rõ <strong>Bán cho người tiêu dùng</strong>.
                      </>
                    ) : null,
                },
                { label: 'Số điện thoại:', name: 'customerPhone' },
                {
                  label: 'Căn cước CD:',
                  name: 'customerPersonalIdentificationNumber',
                  description: 'Căn cước công dân',
                },
                { label: 'Số hộ chiếu:', name: 'customerPassportNumber' },
                ...(invoiceTemplateIdNewYear?.category?.form != 3
                  ? [
                      {
                        label: 'Mã đơn vị quan hệ ngân sách:',
                        name: 'budgetUnitCode',
                      },
                    ]
                  : []),
              ].map(({ label, name, description }) => (
                <div
                  key={name}
                  className="d-flex flex-row align-items-center flex-grow-1"
                >
                  <FormLabel>
                    <span>
                      {label}
                      {description && (
                        <>
                          {' '}
                          <KTTooltip text={description}>
                            <InfoCircleOutlined
                              style={{ color: '#1677ff', cursor: 'pointer' }}
                            />
                          </KTTooltip>
                        </>
                      )}
                    </span>
                  </FormLabel>
                  <div className="w-100">
                    <BaseTextField
                      className="flex-grow-1"
                      name={name}
                      fieldProps={formik.getFieldProps(name)}
                      fieldMeta={formik.getFieldMeta(name)}
                      fieldHelper={formik.getFieldHelpers(name)}
                    />
                  </div>
                </div>
              ))}
            </div>
            {/* <div className="d-flex flex-row flex-wrap gap-3">
              <div className="d-flex flex-row align-items-center flex-grow-1">
                <FormLabel>Căn cước CD:</FormLabel>
                <div className="w-100">
                  <BaseTextField
                    name="customerPersonalIdentificationNumber"
                    fieldProps={formik.getFieldProps(
                      'customerPersonalIdentificationNumber',
                    )}
                    fieldMeta={formik.getFieldMeta(
                      'customerPersonalIdentificationNumber',
                    )}
                    fieldHelper={formik.getFieldHelpers(
                      'customerPersonalIdentificationNumber',
                    )}
                    className="flex-grow-1"
                  />
                </div>
              </div>
            </div> */}
            {/* {isFromPOS ? null : ( */}
            <div
              className="d-flex flex-row"
              style={{ flexWrap: 'wrap', gap: '10px 10px' }}
            >
              {[
                {
                  label: 'STK ngân hàng:',
                  name: 'customerAccountNumber',
                  description: 'Số tài khoản ngân hàng',
                },
                { label: 'Tên ngân hàng:', name: 'customerBankName' },
              ].map(({ label, name, description }) => (
                <div
                  key={name}
                  className="d-flex flex-row align-items-center flex-grow-1"
                >
                  <FormLabel>
                    <span>
                      {label}
                      {description && (
                        <>
                          {' '}
                          <KTTooltip text={description}>
                            <InfoCircleOutlined
                              style={{ color: '#1677ff', cursor: 'pointer' }}
                            />
                          </KTTooltip>
                        </>
                      )}
                    </span>
                  </FormLabel>
                  <div className="w-100">
                    <BaseTextField
                      className="flex-grow-1"
                      name={name}
                      fieldProps={formik.getFieldProps(name)}
                      fieldMeta={formik.getFieldMeta(name)}
                      fieldHelper={formik.getFieldHelpers(name)}
                    />
                  </div>
                </div>
              ))}
            </div>
            {/* )} */}
            <div
              className="d-flex flex-row"
              style={{ flexWrap: 'wrap', gap: '10px 10px' }}
            >
              <div
                className="d-flex flex-row align-items-center"
                style={{ width: '49.45%' }}
              >
                <FormLabel>
                  <span>
                    Hình thức TT:{' '}
                    <KTTooltip text="Hình thức thanh toán">
                      <InfoCircleOutlined
                        style={{ color: '#1677ff', cursor: 'pointer' }}
                      />
                    </KTTooltip>
                  </span>
                </FormLabel>
                <div className="w-100">
                  <CustomSelect
                    autoSize
                    width="max-content"
                    selectOptions={SelectOptions.paymentMethod}
                    currentValue={formik.values.paymentMethod}
                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        'paymentMethod',
                        selectedOption.value,
                      )
                    }}
                  />
                </div>
              </div>
              <div
                className="d-flex flex-row align-items-center"
                style={{ width: '49.45%' }}
              >
                <FormLabel>Email: </FormLabel>
                <div className="w-100">
                  <BaseTextField
                    className="flex-grow-1"
                    name="customerEmail"
                    fieldProps={formik.getFieldProps('customerEmail')}
                    fieldMeta={formik.getFieldMeta('customerEmail')}
                    fieldHelper={formik.getFieldHelpers('customerEmail')}
                  />
                </div>
              </div>
              {isPhuSan && (
                <>
                  {[
                    { label: 'Mã bệnh nhân:', name: 'patientCode' },
                    // { label: 'Bác sĩ:', name: 'doctor' },
                  ].map(({ label, name }) => (
                    <div
                      key={name}
                      className="d-flex flex-row align-items-center w-100"
                    >
                      <FormLabel>{label}</FormLabel>
                      <div className="w-100">
                        <BaseTextField
                          className="flex-grow-1 w-100"
                          name={name}
                          fieldProps={formik.getFieldProps(name)}
                          fieldMeta={formik.getFieldMeta(name)}
                          fieldHelper={formik.getFieldHelpers(name)}
                        />
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
            {/* <div
              className="d-flex flex-row"
              style={{ flexWrap: 'wrap', gap: '10px 10px' }}
            ></div> */}
            {buyerInfoExtendFields?.filter(
              ({ forceShow, show }) => forceShow || show,
            ).length > 0 && (
              <div
                className="d-flex flex-row"
                style={{ flexWrap: 'wrap', gap: '10px 10px' }}
              >
                {buyerInfoExtendFields
                  ?.filter(({ forceShow, show }) => forceShow || show)
                  .map((item, index, { length }) => (
                    <Fragment key={index}>
                      <div className="d-flex flex-row align-items-center flex-grow-1 ">
                        <FormLabel>{item?.label}</FormLabel>
                        <div className="w-100">
                          <BaseTextField
                            className="flex-grow-1"
                            name={`extendFields.${item?.name}`}
                            fieldProps={formik.getFieldProps(
                              `extendFields.${item?.name}`,
                            )}
                            fieldMeta={formik.getFieldMeta(
                              `extendFields.${item?.name}`,
                            )}
                            fieldHelper={formik.getFieldHelpers(
                              `extendFields.${item?.name}`,
                            )}
                          />
                        </div>
                      </div>
                      {length % 2 != 0 && (
                        <div className="d-flex flex-row align-items-center flex-grow-1 opacity-0 visibility-hidden">
                          <FormLabel></FormLabel>
                          <div className="w-100">
                            <BaseTextField className="flex-grow-1" />
                          </div>
                        </div>
                      )}
                    </Fragment>
                  ))}
              </div>
            )}

            <div
              className="d-flex flex-row"
              style={{ flexWrap: 'wrap', gap: '10px 10px' }}
            >
              {invoiceTemplateIdNewYear?.category?.form == 3 &&
                [
                  'buyerAddressTransport',
                  'buyerStartTimeTransport',
                  'buyerEndTimeTransport',
                ].some(
                  (field) =>
                    findObjectInArray(regionConfigs, 'dataField', field)?.show,
                ) && (
                  <div
                    className="d-flex flex-row  w-100"
                    style={{ flexWrap: 'wrap', gap: '10px 10px' }}
                  >
                    {invoiceTemplateIdNewYear?.category?.form == 3 &&
                      findObjectInArray(
                        regionConfigs,
                        'dataField',
                        'buyerAddressTransport',
                      )?.show && (
                        <div className="d-flex flex-row align-items-center w-100">
                          <FormLabel>Địa điểm vận chuyển hàng đến</FormLabel>
                          <div className="w-100">
                            <BaseTextField
                              className="flex-grow-1 w-100"
                              name={'buyerAddressTransport'}
                              fieldProps={formik.getFieldProps(
                                'buyerAddressTransport',
                              )}
                              fieldMeta={formik.getFieldMeta(
                                'buyerAddressTransport',
                              )}
                              fieldHelper={formik.getFieldHelpers(
                                'buyerAddressTransport',
                              )}
                            />
                          </div>
                        </div>
                      )}
                    {invoiceTemplateIdNewYear?.category?.form == 3 && (
                      <div
                        className="d-flex flex-row  w-100"
                        style={{ flexWrap: 'wrap', gap: '10px 10px' }}
                      >
                        {[
                          ...(findObjectInArray(
                            regionConfigs,
                            'dataField',
                            'buyerStartTimeTransport',
                          )?.show
                            ? [
                                {
                                  label: 'Thời gian vận chuyển từ:',
                                  name: 'buyerStartTimeTransport',
                                  type: KTFormInputType.date,
                                },
                              ]
                            : []),
                          ...(findObjectInArray(
                            regionConfigs,
                            'dataField',
                            'buyerEndTimeTransport',
                          )?.show
                            ? [
                                {
                                  label: 'Thời gian vận chuyển đến:',
                                  name: 'buyerEndTimeTransport',
                                  type: KTFormInputType.date,
                                },
                              ]
                            : []),
                        ].map(({ label, name, type }) => (
                          <div
                            key={name}
                            className="d-flex flex-row align-items-center flex-grow-1"
                          >
                            <FormLabel>{label}</FormLabel>
                            <div className="w-100">
                              {(() => {
                                switch (type) {
                                  case KTFormInputType.text:
                                    return (
                                      <BaseTextField
                                        className="flex-grow-1"
                                        name={name}
                                        fieldProps={formik.getFieldProps(name)}
                                        fieldMeta={formik.getFieldMeta(name)}
                                        fieldHelper={formik.getFieldHelpers(
                                          name,
                                        )}
                                      />
                                    )

                                  case KTFormInputType.date:
                                    return (
                                      <DatePicker
                                        style={{ height: 40, width: '100%' }}
                                        placement="bottomLeft"
                                        allowClear={true}
                                        changeOnBlur
                                        name={name}
                                        value={formik.values[name]}
                                        onChange={(date) => {
                                          formik.setFieldValue(name, date)
                                        }}
                                        locale={locale}
                                        // showTime={canSelectTime}
                                        format={'L' /*  : 'L' */}
                                        suffixIcon={
                                          <i className="fa-light fa-calendar"></i>
                                        }
                                        nextIcon={
                                          <i className="fa-regular fa-angle-right"></i>
                                        }
                                        prevIcon={
                                          <i className="fa-regular fa-angle-left"></i>
                                        }
                                        superNextIcon={
                                          <i className="fa-regular fa-angle-double-right"></i>
                                        }
                                        superPrevIcon={
                                          <i className="fa-regular fa-angle-double-left"></i>
                                        }
                                      />
                                    )

                                  default:
                                    return null
                                }
                              })()}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
            </div>

            <div style={{ display: 'none' }}>
              {!partsName.includes('chiet-khau-thuong-mai') && (
                <div
                  className="d-flex flex-row"
                  style={{ flexWrap: 'wrap', gap: '10px 10px' }}
                >
                  {/* <Space size={'large'} className="w-100" wrap>
                    <Checkbox
                      checked={formik?.getFieldProps('statement').value}
                      onChange={(e) => {
                        formik.setFieldValue('statement', e.target.checked)
                      }}
                    >
                      <span style={{ fontSize: 15, color: '#212c36' }}>
                        Lập kèm bảng kê hàng hóa, dịch vụ.
                      </span>
                      {` `}
                    </Checkbox>
                    <span
                      style={{
                        fontSize: 15,
                        color: '#3959f9',
                        cursor: 'pointer',
                        position: 'relative',
                        left: -25,
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.textDecoration = 'underline')
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.textDecoration = 'none')
                      }
                      onClick={() => setOpenGuide(true)}
                    >
                      Xem hướng dẫn
                    </span>
                  </Space> */}
                </div>
              )}

              {/* hóa đơn chiết khấu thương mại */}
              {(partsName.includes('chiet-khau-thuong-mai') ||
                originalInvoiceInfo?.statementNumber ||
                formik?.getFieldProps('statement').value) && (
                <div
                  className="d-flex flex-row"
                  style={{ flexWrap: 'wrap', gap: '10px 10px' }}
                >
                  {/* <div
                    className="d-flex flex-row align-items-center"
                    style={{ width: '49.45%' }}
                  >
                    <FormLabel>Số bảng kê:</FormLabel>
                    <div className="w-100">
                      <BaseTextField
                        className="flex-grow-1 w-100"
                        name="statementNumber"
                        fieldProps={formik.getFieldProps('statementNumber')}
                        fieldMeta={formik.getFieldMeta('statementNumber')}
                        fieldHelper={formik.getFieldHelpers('statementNumber')}
                      />
                    </div>
                  </div> */}
                  {/* <div
                    className="d-flex flex-row align-items-center"
                    style={{ width: '49.45%' }}
                  >
                    <FormLabel>Ngày bảng kê:</FormLabel>
                    <div className="w-100">
                      <DatePicker
                        style={{ height: 40, width: '100%' }}
                        placement="bottomLeft"
                        allowClear={true}
                        changeOnBlur
                        name={'statementIssueDate'}
                        value={formik.values['statementIssueDate']}
                        onChange={(date) => {
                          formik.setFieldValue('statementIssueDate', date)
                        }}
                        locale={locale}
                        format={'L'}
                        suffixIcon={<i className="fa-light fa-calendar"></i>}
                        nextIcon={<i className="fa-regular fa-angle-right"></i>}
                        prevIcon={<i className="fa-regular fa-angle-left"></i>}
                        superNextIcon={
                          <i className="fa-regular fa-angle-double-right"></i>
                        }
                        superPrevIcon={
                          <i className="fa-regular fa-angle-double-left"></i>
                        }
                      />
                    </div>
                  </div> */}
                  {/* <div
                    className="d-flex flex-row align-items-center"
                    style={{ width: '100%' }}
                  >
                    <FormLabel>Đính kèm bảng kê:</FormLabel>
                    <div className="w-100">
                      <UploadFileCustom
                        fileUrl={
                          formik.getFieldProps('statementAttachmentNameFile')
                            ?.value
                        }
                        fileName={getFileNameFromUrl(
                          formik.getFieldProps('statementAttachmentNameFile')
                            ?.value,
                        )}
                        fileBase64={
                          formik.getFieldProps('statementAttachmentBase64')
                            ?.value
                        }
                        onSelectFile={(data) => {
                          // console.log('file chọn:', data)
                          formik.setFieldValue(
                            'statementAttachmentBase64',
                            data?.base64,
                          )
                          formik.setFieldValue(
                            'statementAttachmentNameFile',
                            data?.file?.name,
                          )
                        }}
                        onRemoveFile={() => {
                          formik.setFieldValue(
                            'statementAttachmentNameFile',
                            null,
                          )
                          formik.setFieldValue(
                            'statementAttachmentBase64',
                            null,
                          )
                        }}
                        accept=".pdf,.doc,.docx,.xlsx"
                      />
                    </div>
                  </div> */}
                  {partsName.includes('chiet-khau-thuong-mai') && (
                    <>
                      {/* <div
                        className="d-flex flex-row align-items-center"
                        style={{ width: '100%' }}
                      >
                        <FormLabel>Ghi chú:</FormLabel>
                        <div className="w-100">
                          <BaseTextField
                            className="flex-grow-1 w-100"
                            name="note"
                            fieldProps={formik.getFieldProps('note')}
                            fieldMeta={formik.getFieldMeta('note')}
                            fieldHelper={formik.getFieldHelpers('note')}
                          />
                        </div>
                      </div>
                      <div
                        className="d-flex flex-row align-items-center"
                        style={{ width: '100%' }}
                      >
                        <FormLabel>Danh sách hóa đơn liên quan:</FormLabel>
                        <div className="w-100">
                          <InvoiceTradeDiscount
                            data={
                              formik.getFieldProps('invoicesTrandeDiscount')
                                .value
                            }
                            setData={(data) => {
                              formik.setFieldValue(
                                'invoicesTrandeDiscount',
                                data,
                              )
                            }}
                            visible
                          />
                        </div>
                      </div> */}
                      {/* {formik.getFieldProps('invoicesTrandeDiscount')?.value
                        ?.length > 0 && (
                        <div
                          className="d-flex flex-row align-items-center"
                          style={{ width: '100%', cursor: 'pointer' }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.color = '#1677ff'
                            e.currentTarget.style.textDecoration = 'underline'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.color = ''
                            e.currentTarget.style.textDecoration = ''
                          }}
                          onClick={() => {
                            setFindListInvoiceModalShow(true)
                          }}
                        >
                          Xem chi tiết
                        </div>
                      )} */}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="create-invoice-right-col">
            <div className="d-flex flex-row align-items-center w-100">
              <FormLabel width="60px">Ký hiệu</FormLabel>
              <CustomSelect
                classNamePrefix="rs-kyhieu"
                placeholder={'Chọn ký hiệu'}
                currentValue={formik.values.invoiceTemplateId}
                width="300px"
                selectOptions={templateInvoiceSerials}
                customFilterFn={(option, searchText) => {
                  return (
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase()) ||
                    option.data.name
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  )
                }}
                onChange={(selectedOption) =>
                  handleSelectInvoiceSerial(selectedOption)
                }
                components={{
                  MenuList,
                  Option,
                }}
                // menuIsOpen
              />
            </div>
            <div className="d-flex flex-row align-items-center w-100">
              <FormLabel width="60px">Số:</FormLabel>
              <div className="w-100 position-relative">
                <BaseTextField
                  disabled={true}
                  className="flex-grow-1"
                  placeholder={
                    actionType === ACTION_TYPE.CREATE ? '<Chưa cấp số>' : ''
                  }
                  additionalInputClassName={
                    actionType === ACTION_TYPE.CREATE
                      ? 'invoice-number-placeholder'
                      : ''
                  }
                ></BaseTextField>
                {actionType === ACTION_TYPE.CREATE && (
                  <KTTooltip text="Số hóa đơn sẽ được cấp sau khi phát hành">
                    <span
                      className="position-absolute"
                      style={{
                        top: '50%',
                        right: '12px',
                        transform: 'translateY(-50%)',
                        color: '#1677ff',
                        cursor: 'pointer',
                      }}
                    >
                      <InfoCircleOutlined />
                    </span>
                  </KTTooltip>
                )}
              </div>
            </div>
            {parseInt(formik.values?.serial?.charAt(0)) === 2 && (
              <div className="d-flex flex-row mt-2">
                <Checkbox
                  checked={isTaxReduction}
                  onChange={onCheckTaxReduction}
                >
                  Áp dụng giảm thuế GTGT theo nghị quyết số 204/2025/QH15
                </Checkbox>
              </div>
            )}
          </div>
        </div>
        {renderDescription()}
      </div>
      <CheckCustomerStatusModal
        show={checkCustomerStatusModalShow}
        onHide={() => setCheckCustomerStatusModalShow(false)}
        taxCode={formik.values?.customerTaxCode}
        companyName={formik.values?.customerCompanyName}
        address={formik.values?.customerFullAddress}
        dateOfOperation={formik.values?.dateOfOperation}
        status={formik.values?.status}
      />
      <ModalEditCustomer
        show={showingModalEditCustomer}
        onClose={() => {
          setShowingModalEditCustomer(false)
        }}
        active="ADD"
        onRefreshCustomerList={() => {
          queryCache.invalidate()
        }}
        customerItem={{
          taxCode: formik.values.customerTaxCode,
          type: AppData?.customerType[0]?.value,
        }}
      />
      <ModalListInvoice
        checkBoxShow={false}
        show={findListInvoiceModalShow}
        onHide={() => setFindListInvoiceModalShow(false)}
        title="Danh sách hóa đơn là căn cứ để chiết khấu thương mại"
        buttonAgreeVisibility={true}
        selectableRows={[]}
        buttonAgreeOnlick={async (data) => {}}
        buttonAgreeTab2Onlick={async () => {}}
        data={formik.getFieldProps('invoicesTrandeDiscount').value}
      />

      <ModalGuideInvoice open={openGuide} onClose={() => setOpenGuide(false)} />
    </>
  )
}

export default memo(InvoiceGeneralInfo)
